// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fit-content[data-v-31832fe6]{width:-moz-fit-content;width:fit-content}.error-page-container[data-v-31832fe6]{display:grid;grid-template-columns:repeat(12,minmax(0,1fr));margin-bottom:2rem;margin-top:2rem;padding-left:24px;padding-right:24px}@media (min-width:768px){.error-page-container[data-v-31832fe6]{padding-left:5vw;padding-right:5vw}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
